module.exports = __webpack_public_path__ + "img/not.a82f3c16.png";